import React from 'react';

import Skeleton from '@mui/material/Skeleton';

const FormLoader = () => (
  <>
    <div className="form-group">
      <Skeleton className="form-label" variant="text" width={210} />
      <Skeleton className="form-control text-input" />
    </div>
    <div className="form-group">
      <Skeleton className="form-label" variant="text" width={210} />
      <Skeleton className="form-control text-input" />
    </div>
    <div className="form-group">
      <Skeleton className="form-label" variant="text" width={210} />
      <Skeleton className="form-control text-input" />
    </div>
    <div className="form-group">
      <Skeleton className="form-label" variant="text" width={210} />
      <Skeleton className="form-control text-input" />
    </div>
    <div className="form-group">
      <Skeleton className="form-label" variant="text" width={210} />
      <Skeleton className="form-control text-input" />
    </div>
    <div className="form-group">
      <Skeleton className="form-label" variant="text" width={210} />
      <Skeleton className="form-control text-input" />
    </div>
    <div className="form-group">
      <Skeleton className="form-label" variant="text" width={210} />
      <Skeleton className="form-control text-input" />
    </div>
    <div className="form-group">
      <Skeleton className="form-label" variant="text" width={210} />
      <Skeleton className="form-control text-input" />
    </div>
    <div className="form-group">
      <Skeleton className="form-label" variant="text" width={210} />
      <Skeleton className="form-control text-input" />
    </div>
  </>
);

export default FormLoader;
